// Login (design_handoff_login): reine Hilfen. getBrowserInfo unverändert aus pages/Login.tsx herausgelöst –
// gleiche Reihenfolge der Prüfungen, gleiche Werte für login_history.

export function getBrowserInfo(ua: string): { browser: string; os: string; ua: string } {
  let browser = 'Unbekannt';
  let os = 'Unbekannt';

  if (ua.includes('Firefox')) browser = 'Firefox';
  else if (ua.includes('Chrome')) browser = 'Chrome';
  else if (ua.includes('Safari')) browser = 'Safari';
  else if (ua.includes('Edge')) browser = 'Edge';

  if (ua.includes('Windows')) os = 'Windows';
  else if (ua.includes('Mac OS')) os = 'macOS';
  else if (ua.includes('Linux')) os = 'Linux';
  else if (ua.includes('Android')) os = 'Android';
  else if (ua.includes('iPhone')) os = 'iOS';

  return { browser, os, ua };
}

/** Modi der Login-Karte (README §2). */
export type LoginModus = 'login' | 'reset' | 'sent' | 'newpw' | 'pwdone';

export interface KartenZustand {
  modus: LoginModus;
  error: string | null;
  password: string;
  confirmPassword: string;
}

/** Moduswechsel: löscht immer den Fehler; zurück zum Login leert zusätzlich die Passwortfelder. */
export function wechsleModus(z: KartenZustand, ziel: LoginModus): KartenZustand {
  return {
    ...z,
    modus: ziel,
    error: null,
    ...(ziel === 'login' ? { password: '', confirmPassword: '' } : {}),
  };
}

/** Titel der Karte je Modus. */
export const MODUS_TITEL: Record<LoginModus, string> = {
  login: 'Kunden-Login',
  reset: 'Passwort zurücksetzen',
  sent: 'Passwort zurücksetzen',
  newpw: 'Neues Passwort',
  pwdone: 'Neues Passwort',
};
